// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blocked-community-postcard-main-container {
  height: 100%;
  overflow-y: auto;
  scrollbar-width: thin;
  margin-bottom: 10px;
}
.ans-reply-post-card {
  display: flex;
  flex-direction: column;
  margin: 15px 0 10px 0;
  padding: 10px 10px 7px 10px;
  border-width: 0;
  border-radius: 20px;
  background-color: #f9f9f8;
  opacity: 0.95;

  /* Responsiveness */
  width: 100%; /* fills modal container */
  max-width: 550px; /* prevents being too wide */
  box-sizing: border-box;
}
.locationContent {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 400px;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}

.blocked-community-postcard {
  display: flex;
  flex-direction: column;
  /* justify-content: center;
      align-items: center; */
  margin: 10px;
  padding: 14px 14px;
  overflow-x: auto;
  border-width: 0px;
  border-radius: 20px;
  /* box-shadow: 0px 2px 8px rgb(139, 146, 149); */
  background-color: #f9f9f8;
  opacity: 0.9;
  width: 340px;
}

@media screen and (min-width: 768px) {
  .blocked-community-postcard {
    width: 340px;
  }
}

@media screen and (min-width: 1024px) {
  .blocked-community-postcard {
    width: 420px;
  }
}

.blocked-community-text {
  font-family: sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #707070;
}
.blocked-community-req-send-time-text {
  font-family: sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #707070;
  margin-bottom: 2px;
}
.blocked-community-time-text {
  font-family: sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: #707070;
}

.ans-and-reply--modal-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 8px;
}

.IgnoreRemoveBtnContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  margin: 15px 0 8px 0;
  gap: 20px;
}
.IgnoreRemoveBtn {
  background-color: #efeeed;
  border: none;
  border-radius: 20px;
  padding: 5px 10px;
  width: 30%;
  color: #373334;
  font-size: 14px;
  outline: none;
  cursor: pointer;
}
.ans-and-reply--modal-header button {
  border: none;
  background-color: transparent;
  outline: none;
}
.ans-and-reply-icon-container {
  margin: auto;
}
.block-modal-close-icon {
  font-size: 22px;
}

.ans-modal-saysandfollow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 8px 0;
}

.ans-modal-noOfsays,
.ans-modal-noOffollows {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
}

.ans-modal-action-link {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  text-decoration: none;
  color: #373334;
  font-size: 14px;
  font-weight: 500;
}

.ans-modal-action-link:hover {
  opacity: 0.8;
}

.warn-reason-textarea {
  width: 100%;
  max-width: 520px;
  padding: 15px 18px;
  border-width: 1.6px;
  border-color: #707070c1;
  margin: 8px 0px;
  box-sizing: border-box;
  resize: none;
}
.char-count {
  text-align: right;
  margin-right: 20px;
}
.unblock-req-send-button {
  width: 88px;
  height: 33px;
  border: none;
  border-radius: 20px;
  background: linear-gradient(123deg, #6ca8e1 0%, #4795de 49%, #0071dd 100%);
  color: white;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  outline: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Notifications/AnswerAndReplyNotificationModal/answerAndReplyNotificationModal.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;;EAEb,mBAAmB;EACnB,WAAW,EAAE,0BAA0B;EACvC,gBAAgB,EAAE,4BAA4B;EAC9C,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB;4BAC0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gDAAgD;EAChD,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,eAAe;EACf,aAAa;EACb,eAAe;AACjB;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,0EAA0E;EAC1E,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;AAC1B","sourcesContent":[".blocked-community-postcard-main-container {\r\n  height: 100%;\r\n  overflow-y: auto;\r\n  scrollbar-width: thin;\r\n  margin-bottom: 10px;\r\n}\r\n.ans-reply-post-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 15px 0 10px 0;\r\n  padding: 10px 10px 7px 10px;\r\n  border-width: 0;\r\n  border-radius: 20px;\r\n  background-color: #f9f9f8;\r\n  opacity: 0.95;\r\n\r\n  /* Responsiveness */\r\n  width: 100%; /* fills modal container */\r\n  max-width: 550px; /* prevents being too wide */\r\n  box-sizing: border-box;\r\n}\r\n.locationContent {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  max-width: 400px;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  cursor: pointer;\r\n}\r\n\r\n.blocked-community-postcard {\r\n  display: flex;\r\n  flex-direction: column;\r\n  /* justify-content: center;\r\n      align-items: center; */\r\n  margin: 10px;\r\n  padding: 14px 14px;\r\n  overflow-x: auto;\r\n  border-width: 0px;\r\n  border-radius: 20px;\r\n  /* box-shadow: 0px 2px 8px rgb(139, 146, 149); */\r\n  background-color: #f9f9f8;\r\n  opacity: 0.9;\r\n  width: 340px;\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .blocked-community-postcard {\r\n    width: 340px;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1024px) {\r\n  .blocked-community-postcard {\r\n    width: 420px;\r\n  }\r\n}\r\n\r\n.blocked-community-text {\r\n  font-family: sans-serif;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: #707070;\r\n}\r\n.blocked-community-req-send-time-text {\r\n  font-family: sans-serif;\r\n  font-weight: 500;\r\n  font-size: 12px;\r\n  color: #707070;\r\n  margin-bottom: 2px;\r\n}\r\n.blocked-community-time-text {\r\n  font-family: sans-serif;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: #707070;\r\n}\r\n\r\n.ans-and-reply--modal-header {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.IgnoreRemoveBtnContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-evenly;\r\n  align-items: center;\r\n  width: 100%;\r\n  margin: 15px 0 8px 0;\r\n  gap: 20px;\r\n}\r\n.IgnoreRemoveBtn {\r\n  background-color: #efeeed;\r\n  border: none;\r\n  border-radius: 20px;\r\n  padding: 5px 10px;\r\n  width: 30%;\r\n  color: #373334;\r\n  font-size: 14px;\r\n  outline: none;\r\n  cursor: pointer;\r\n}\r\n.ans-and-reply--modal-header button {\r\n  border: none;\r\n  background-color: transparent;\r\n  outline: none;\r\n}\r\n.ans-and-reply-icon-container {\r\n  margin: auto;\r\n}\r\n.block-modal-close-icon {\r\n  font-size: 22px;\r\n}\r\n\r\n.ans-modal-saysandfollow {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  width: 100%;\r\n  padding: 8px 0;\r\n}\r\n\r\n.ans-modal-noOfsays,\r\n.ans-modal-noOffollows {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex: 1;\r\n}\r\n\r\n.ans-modal-action-link {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n  color: #373334;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n\r\n.ans-modal-action-link:hover {\r\n  opacity: 0.8;\r\n}\r\n\r\n.warn-reason-textarea {\r\n  width: 100%;\r\n  max-width: 520px;\r\n  padding: 15px 18px;\r\n  border-width: 1.6px;\r\n  border-color: #707070c1;\r\n  margin: 8px 0px;\r\n  box-sizing: border-box;\r\n  resize: none;\r\n}\r\n.char-count {\r\n  text-align: right;\r\n  margin-right: 20px;\r\n}\r\n.unblock-req-send-button {\r\n  width: 88px;\r\n  height: 33px;\r\n  border: none;\r\n  border-radius: 20px;\r\n  background: linear-gradient(123deg, #6ca8e1 0%, #4795de 49%, #0071dd 100%);\r\n  color: white;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: auto;\r\n  outline: none !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
